export const vietnameseCrmMessages = {
  resources: {
    leads: {
      name: "Ứng viên |||| Ứng viên",
      forcedCaseName: "Ứng viên",
      fields: {
        name: "Họ tên",
        phone: "Số điện thoại",
        desired_job: "Công việc mong muốn",
        lead_score: "Điểm đánh giá",
        lead_stage: "Giai đoạn",
        expected_salary: "Lương mong muốn",
      },
    },
    conversations: {
      name: "Tin nhắn |||| Tin nhắn",
      forcedCaseName: "Tin nhắn",
      fields: {
        mode: "Chế độ trả lời",
        last_inbound_at: "Tin nhắn cuối",
        assigned_recruiter_id: "Người phụ trách",
      },
      reply: {
        disabled: "Tính năng trả lời chưa được cấu hình.",
        unauthorized: "Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại.",
        forbidden: "Tài khoản không có quyền gửi tin nhắn.",
        conflict:
          "Hội thoại đang được người khác tiếp quản. Hãy Tiếp nhận trước khi trả lời.",
        unavailable:
          "Không thể gửi tin qua Zalo lúc này. Hãy chờ ứng viên nhắn lại rồi thử lại.",
        provider:
          "Zalo chưa nhận được tin nhắn. Bạn có thể thử lại ngay trên bong bóng tin nhắn.",
        network: "Không kết nối được đến máy chủ. Vui lòng thử lại.",
        error: "Gửi tin nhắn thất bại.",
      },
      // The channel-naming reply failures (`unavailable` / `provider`) re-keyed
      // for Messenger conversations — a Messenger failure must not be reported
      // as a Zalo one. Neutral statuses (conflict/network/…) stay in `reply`.
      reply_messenger: {
        unavailable:
          "Không thể gửi tin qua Messenger lúc này. Hãy chờ ứng viên nhắn lại rồi thử lại.",
        provider:
          "Messenger chưa nhận được tin nhắn. Bạn có thể thử lại ngay trên bong bóng tin nhắn.",
      },
    },
    projects: {
      name: "Dự án |||| Dự án",
      forcedCaseName: "Dự án",
    },
    users: {
      name: "Tài khoản |||| Tài khoản",
      forcedCaseName: "Tài khoản",
      fields: {
        full_name: "Họ tên",
        email: "Email",
        first_name: "Tên",
        last_name: "Họ",
        role: "Vai trò",
      },
      action: {
        new: "Tài khoản mới",
      },
    },
    settings: {
      name: "Cài đặt |||| Cài đặt",
      forcedCaseName: "Cài đặt",
    },
  },
  dashboard: {
    queue_loading: "Đang tải hàng đợi tuyển dụng",
    updated_at: "Cập nhật lúc %{time}",
    queue_refresh_failed:
      "Không thể làm mới hàng đợi. Danh sách hiện tại vẫn được giữ lại.",
    queues_label: "Các hàng đợi tuyển dụng",
    todo_title: "Cần xử lý",
    todo_count_loading: "Đang tải số hội thoại cần xử lý",
    todo_count_failed: "Không tải được số hội thoại cần xử lý",
    todo_count: "%{count} hội thoại cần xử lý",
    conversations_load_failed: "Không tải được hội thoại.",
    candidates_title: "Ứng viên mới",
    candidates_count_loading: "Đang tải số ứng viên mới",
    candidates_count_failed: "Không tải được số ứng viên mới",
    candidates_count: "%{count} ứng viên mới",
    candidates_load_failed: "Không tải được ứng viên.",
  },
  performance: {
    error_title: "Không tải được số liệu hiệu suất",
  },
  leads: {
    profile_title: "Thông tin ứng viên",
    fallback_name: "Ứng viên",
    fallback_new_candidate: "Ứng viên mới",
    no_phone: "Chưa có số điện thoại",
    recorded_in_notes: "Đã ghi trong ghi chú",
    needs_follow_up: "Cần hỏi thêm",
    fields: {
      name: "Họ tên",
      phone: "Số điện thoại",
      birth_year: "Năm sinh",
      birth_year_and_age: "Năm sinh / tuổi",
      age: "Tuổi",
      region: "Khu vực muốn làm",
      living_area: "Khu vực đang sống",
      date_of_birth: "Ngày sinh / tuổi",
      citizen_id: "CCCD",
      gender: "Giới tính",
      desired_job: "Công việc mong muốn",
      expectation: "Mong muốn",
      experience: "Kinh nghiệm",
      expected_salary: "Mức lương mong muốn",
      salary: "Mức lương",
      area: "Khu vực",
      address: "Địa chỉ hiện tại",
      notes: "Ghi chú",
      housing: "Chỗ ở",
      pickup: "Xe đưa đón",
    },
  },
  conversations: {
    list: {
      empty_title: "Chưa có cuộc trò chuyện",
      empty_description:
        "Các cuộc trò chuyện mới từ liên hệ sẽ xuất hiện tại đây.",
      filtered_title: "Không tìm thấy hội thoại",
      filtered_description: "Thử xoá từ khoá tìm kiếm hoặc bộ lọc để xem thêm.",
      clear_search_and_filters: "Xoá tìm kiếm và bộ lọc",
      error_title: "Không thể tải hội thoại",
      error_description: "Kiểm tra kết nối và thử lại.",
      search_candidate: "Tìm ứng viên hoặc số điện thoại",
      search_contact: "Tìm liên hệ",
    },
    takeover: {
      success: "Đã chuyển sang Tư vấn viên",
      error: "Tiếp nhận hội thoại thất bại",
    },
    semi_auto: {
      success: "Đã bật chế độ bán tự động",
      error: "Không thể bật chế độ bán tự động",
    },
    release: {
      success: "Đã chuyển sang ChatBot",
      error: "Trả hội thoại về ChatBot thất bại",
    },
    force_reply: {
      success: "Bot đang soạn trả lời cho tin nhắn chờ.",
      error: "Không tìm thấy tin nhắn ứng viên nào đang chờ trả lời.",
    },
    bot_reply: {
      success: "Bot đang đọc hội thoại và sẽ trả lời nếu cần.",
      error: "Không yêu cầu bot trả lời được. Thử lại sau.",
    },
  },
  crm: {
    navigation: {
      overview: "Tổng quan",
    },
    profile: {
      title: "Hồ sơ cá nhân",
      updated: "Hồ sơ của bạn đã được cập nhật",
      update_error: "Đã xảy ra lỗi. Vui lòng thử lại",
    },
    common: {
      saving: "Đang lưu…",
      save_changes: "Lưu thay đổi",
      save_and_test: "Lưu & kiểm tra",
      save_credentials: "Lưu thông tin",
      save_project: "Lưu dự án",
      save_file: "Lưu tệp",
      retry: "Thử lại",
      retrying: "Đang thử lại…",
      unknown: "Chưa rõ",
      retry_hint: "Kiểm tra kết nối rồi thử lại.",
      back_to_overview: "Về Tổng quan",
      no_data: "Chưa có dữ liệu",
      unsaved_changes: "Có thay đổi chưa lưu.",
      token_encrypted_hint: "Token được mã hoá, không hiển thị lại.",
      refreshing: "Đang làm mới…",
      testing: "Đang kiểm tra",
      test: "Kiểm tra",
      uploading: "Đang tải lên…",
      upload: "Tải lên",
    },
    language: "Ngôn ngữ",
    users: {
      access_denied_help:
        "Chỉ quản trị viên mới được quản lý người dùng. Hãy nhờ quản trị viên cấp quyền truy cập.",
    },
  },
  ra: {
    action: {
      add: "Thêm",
      add_filter: "Thêm bộ lọc",
      back: "Quay lại",
      cancel: "Hủy",
      clear: "Xóa sạch",
      clear_array_input: "Xóa toàn bộ danh sách",
      clear_input_value: "Xóa giá trị",
      clear_search: "Xóa tìm kiếm",
      clone: "Nhân bản",
      close: "Đóng",
      close_menu: "Đóng menu",
      configure: "Cấu hình",
      confirm: "Xác nhận",
      create: "Tạo",
      create_record: "Tạo mới",
      delete: "Xóa",
      delete_file: "Xóa tệp",
      edit: "Sửa",
      edit_record: "Sửa bản ghi",
      expand: "Mở rộng",
      export: "Xuất",
      find: "Tìm",
      hide_filter: "Ẩn bộ lọc",
      import: "Nhập",
      list: "Danh sách",
      move_all_left: "Chuyển tất cả sang trái",
      move_all_right: "Chuyển tất cả sang phải",
      move_down: "Xuống",
      move_left: "Trái",
      move_right: "Phải",
      move_up: "Lên",
      next: "Tiếp",
      open: "Mở",
      prev: "Trước",
      refresh: "Làm mới",
      remove: "Gỡ bỏ",
      remove_all_filters: "Xóa tất cả bộ lọc",
      remove_filter: "Gỡ bộ lọc này",
      reorder: "Sắp xếp lại",
      reset: "Đặt lại",
      save: "Lưu",
      save_and_add: "Lưu và thêm",
      search: "Tìm kiếm",
      search_columns: "Tìm cột",
      select_all: "Chọn tất cả",
      select_columns: "Cột",
      select_row: "Chọn dòng",
      show: "Xem",
      show_filter: "Hiện bộ lọc",
      show_record: "Xem bản ghi",
      sort: "Sắp xếp",
      undo: "Hoàn tác",
      unselect: "Bỏ chọn",
      update: "Cập nhật",
      view: "Xem",
    },
    page: {
      access_denied: "Truy cập bị từ chối",
      create: "Tạo mới %{name}",
      dashboard: "Tổng quan",
      edit: "%{name} #%{id}",
      empty: "Chưa có %{name}",
      error: "Có lỗi xảy ra",
      list: "%{name}",
      loading: "Đang tải",
      invite: "Bạn có muốn thêm mới?",
      not_found: "Không tìm thấy",
      show: "%{name} #%{id}",
    },
    navigation: {
      first: "Trang đầu",
      last: "Trang cuối",
      next: "Trang tiếp",
      no_more_results: "Hết kết quả",
      no_results: "Không có kết quả",
      page_out_of_boundaries: "Trang ngoài phạm vi",
      page_out_of_boundaries_link: "Về trang cuối",
      previous: "Về trang trước",
      page_range: "%{offsetBegin}-%{offsetEnd} trên tổng số %{total}",
      page_range_empty: "Không có kết quả",
      page_rows_per_page: "Số dòng mỗi trang",
      prev: "Trang trước",
      skip_results: "Bỏ qua kết quả",
    },
    message: {
      bad_request: "Yêu cầu không hợp lệ",
      confirm_delete_all: {
        content: "Bạn có chắc muốn xóa %{smart_count} mục đã chọn?",
        title: "Xóa các mục đã chọn?",
      },
      clear_array_input: "Bạn có chắc muốn xóa toàn bộ danh sách?",
      content_delete_confirm: "Bạn có chắc muốn xóa mục này?",
      created: "Đã tạo %{name}",
      deleting: "Đang xóa…",
      deleting_multiple_items: "Đang xóa %{smart_count} mục…",
      deleting_one_item: "Đang xóa 1 mục…",
      delete_confirm: "Bạn có chắc muốn xóa %{name}?",
      delete_final_confirm:
        "Hành động này không thể hoàn tác. Bạn có chắc muốn xóa %{name}?",
      delete_title: "Xóa %{name} #%{id}",
      deleted: "Đã xóa %{name}",
      deleted_and_downgraded: "Đã xóa %{name} và thu hồi quyền",
      fetch_multiple_error: "Không thể tải %{smart_count} mục",
      fetch_one_error: "Không thể tải mục này",
      forbidden: "Bạn không có quyền thực hiện hành động này",
      invalid_form: "Biểu mẫu không hợp lệ",
      loading: "Đang tải…",
      network_error: "Lỗi kết nối mạng",
      no_results: "Không có kết quả",
      not_found: "Không tìm thấy tài nguyên",
      something_things_wrong: "Đã có lỗi xảy ra",
      updated: "Đã cập nhật %{name}",
    },
    notification: {
      bad_item: "Mục không hợp lệ",
      contextual_action_does_not_exist: "Hành động không tồn tại",
      created: "Đã tạo %{name} thành công",
      data_provider_error: "Lỗi dữ liệu. Vui lòng thử lại.",
      deleted: "Đã xóa %{name} thành công",
      i18n_error: "Không tìm thấy bản dịch cho khóa '%{name}'",
      item_does_not_exist: "Mục không tồn tại",
      logged_out: "Phiên đăng nhập đã hết hạn",
      not_found: "Không tìm thấy trang",
      updated: "Đã cập nhật %{name} thành công",
    },
    input: {
      image: {
        upload_several: "Kéo thả hoặc nhấn để chọn ảnh",
        upload_single: "Kéo thả hoặc nhấn để chọn ảnh",
      },
      file: {
        upload_several: "Kéo thả hoặc nhấn để chọn tệp",
        upload_single: "Kéo thả hoặc nhấn để chọn tệp",
      },
      date: {
        days_ago: "%{smart_count} ngày trước",
        months_ago: "%{smart_count} tháng trước",
        today: "Hôm nay",
        years_ago: "%{smart_count} năm trước",
        yesterday: "Hôm qua",
      },
      boolean: {
        false: "Không",
        true: "Có",
      },
      password: {
        hidden: "Hiện mật khẩu",
        visible: "Ẩn mật khẩu",
      },
      autocomplete: {
        create_label: 'Tạo "%{name}"',
        empty: "Không có kết quả",
      },
    },
    form: {
      message: {
        invalid_form:
          "Biểu mẫu có lỗi. Vui lòng kiểm tra lại các trường đánh dấu.",
      },
      alert: {
        save_form_error: "Không thể lưu biểu mẫu.",
      },
    },
    sort: {
      asc: "Tăng dần",
      desc: "Giảm dần",
      sort_by: "Sắp xếp theo %{field_lower_first} %{order}",
    },
    auth: {
      sign_in: "Đăng nhập",
      sign_in_button: "Đăng nhập",
      access_denied: "Truy cập bị từ chối",
      sign_in_error: "Đăng nhập thất bại",
      sign_out: "Đăng xuất",
      logout: "Đăng xuất",
      title: "Đăng nhập vào %{name}",
      user_menu: "Tài khoản",
      username: "Tài khoản",
      email: "Email",
      password: "Mật khẩu",
      remember_me: "Ghi nhớ đăng nhập",
    },
    saved_queries: {
      new_dialog_title: "Lưu truy vấn hiện tại",
      new_label: "Lưu truy vấn hiện tại…",
      query_name: "Tên truy vấn",
      remove_dialog_title: "Gỡ truy vấn đã lưu?",
      remove_label_with_name: 'Gỡ truy vấn "%{name}"',
      remove_message:
        "Bạn có chắc muốn gỡ mục này khỏi danh sách truy vấn đã lưu?",
    },
    validation: {
      required: "Trường này là bắt buộc",
      minLength: "Cần ít nhất %{min} ký tự",
      maxLength: "Không được vượt quá %{max} ký tự",
      minValue: "Giá trị tối thiểu là %{min}",
      maxValue: "Giá trị tối đa là %{max}",
      number: "Phải là số",
      email: "Email không hợp lệ",
    },
  },
};
